import React from 'react';
import { useTranslation } from 'react-i18next';
import KpiWidget from './KpiWidget';

const MessagesKpiWidget = ({ totalMessages = 0 }) => {
  const { t } = useTranslation();

  return (
    <KpiWidget
      label={t('dashboard.messages')}
      value={totalMessages.toLocaleString()}
      hint={t('dashboard.currentWeek')}
    />
  );
};

export default MessagesKpiWidget;
